var _style, _font, _font2, _rect, _text, _g, _path, _rect2, _text2, _path2, _g2, _rect3, _text3, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectGalaxyStepsV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 294.8 159.2",
    style: {
      enableBackground: "new 0 0 294.8 159.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{font-family:'Inter-Light';}\n\t.st3{font-size:10px;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#6AC3E2;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#6E9FD4;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#F2852F;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#F1C32E;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#CBDC37;}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#B5D66D;}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#F26A21;}\n\t.st11{opacity:0.7;fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st12{opacity:0.8;fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st13{font-family:'Inter-SemiBold';}\n\t.st14{fill:#0088BB;}\n")), _font || (_font = /*#__PURE__*/React.createElement("font", {
    horizAdvX: 2816
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Inter-SemiBold",
    unitsPerEm: 2816,
    underlinePosition: -445,
    underlineThickness: 243
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 2904,
    d: "M277,-640l2350,0l0,512l-2350,0M277,64l2350,0l0,512l-2350,0M277,768l2350,0l0,512l-2350,0M277,1472l2350,0l0,512l-2350,0M277,2176l2350,0l0,512l-2350,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 699
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 1354,
    d: "M1015,2048l-353,0l-509,-327l0,-340l479,306l12,0l0,-1687l371,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1726,
    d: "M548,900C548,1122 686,1250 880,1250C1070,1250 1182,1129 1182,922l0,-922l362,0l0,978C1544,1349 1334,1556 1015,1556C779,1556 629,1449 558,1275l-18,0l0,773l-354,0l0,-2048l362,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1712,
    d: "M856,-30C1306,-30 1592,287 1592,762C1592,1238 1306,1556 856,1556C406,1556 120,1238 120,762C120,287 406,-30 856,-30M858,260C609,260 487,482 487,763C487,1044 609,1269 858,1269C1103,1269 1225,1044 1225,763C1225,482 1103,260 858,260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 1117,
    d: "M186,0l362,0l0,903C548,1098 695,1236 894,1236C955,1236 1031,1225 1062,1215l0,333C1029,1554 972,1558 932,1558C756,1558 609,1458 553,1280l-16,0l0,256l-351,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1713,
    d: "M1165,646C1165,412 998,296 838,296C664,296 548,419 548,614l0,922l-362,0l0,-978C186,189 396,-20 698,-20C928,-20 1090,101 1160,273l16,0l0,-273l351,0l0,1536l-362,0z"
  }))), _font2 || (_font2 = /*#__PURE__*/React.createElement("font", {
    horizAdvX: 2816
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Inter-Light",
    unitsPerEm: 2816,
    underlinePosition: -469,
    underlineThickness: 149
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 2748,
    d: "M233,-640l2282,0l0,512l-2282,0M233,64l2282,0l0,512l-2282,0M233,768l2282,0l0,512l-2282,0M233,1472l2282,0l0,512l-2282,0M233,2176l2282,0l0,512l-2282,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 792
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1848,
    d: "M275,0l219,617l860,0l219,-617l196,0l-745,2048l-200,0l-745,-2048M554,785l363,1020l14,0l363,-1020z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 2044,
    d: "M1876,1408C1809,1785 1501,2076 1065,2076C548,2076 180,1665 180,1024C180,383 548,-28 1065,-28C1501,-28 1809,264 1876,640l-188,0C1631,359 1386,148 1065,148C677,148 361,455 361,1024C361,1591 677,1900 1065,1900C1386,1900 1631,1688 1688,1408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1671,
    d: "M272,0l1208,0l0,168l-1021,0l0,773l938,0l0,168l-938,0l0,771l1001,0l0,168l-1188,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1651,
    d: "M272,0l187,0l0,941l905,0l0,168l-905,0l0,771l998,0l0,168l-1185,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 2088,
    d: "M1689,1408l192,0C1815,1769 1508,2076 1060,2076C541,2076 180,1666 180,1024C180,383 537,-28 1073,-28C1552,-28 1895,299 1895,824l0,168l-778,0l0,-168l596,0C1708,405 1445,148 1073,148C659,148 361,474 361,1024C361,1576 661,1900 1060,1900C1398,1900 1615,1680 1689,1408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1584,
    d: "M272,0l1163,0l0,168l-976,0l0,1880l-187,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 2480,
    d: "M272,2048l0,-2048l176,0l0,1653l16,0l691,-1653l170,0l691,1653l16,0l0,-1653l176,0l0,2048l-216,0l-743,-1784l-18,0l-743,1784z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1781,
    d: "M148,1880l649,0l0,-1880l187,0l0,1880l649,0l0,168l-1485,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1755,
    d: "M304,2048l-221,0l669,-1024l-669,-1024l221,0l567,879l13,0l567,-879l221,0l-659,1024l659,1024l-221,0l-567,-889l-13,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1567,
    d: "M664,-35C920,-35 1076,107 1140,243l11,0l0,-243l178,0l0,1043C1329,1455 1019,1557 784,1557C549,1557 307,1464 203,1213l169,-61C428,1284 567,1397 789,1397C1022,1397 1151,1269 1151,1059l0,-36C1151,907 1007,905 749,873C402,830 159,733 159,429C159,133 385,-35 664,-35M688,128C487,128 337,235 337,421C337,607 489,685 749,717C875,732 1099,760 1151,811l0,-222C1151,337 972,128 688,128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1567,
    d: "M835,-32C1155,-32 1380,170 1421,448l-180,0C1200,252 1039,131 835,131C534,131 335,393 335,767C335,1139 540,1395 835,1395C1054,1395 1202,1254 1240,1080l180,0C1378,1365 1140,1557 832,1557C430,1557 156,1223 156,761C156,303 422,-32 835,-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1727,
    d: "M788,-32C1067,-32 1197,145 1260,285l21,0l0,-285l174,0l0,2048l-179,0l0,-805l-16,0C1199,1381 1072,1557 791,1557C412,1557 156,1237 156,764C156,287 411,-32 788,-32M809,131C503,131 335,409 335,767C335,1121 501,1395 809,1395C1109,1395 1279,1135 1279,767C1279,396 1107,131 809,131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1635,
    d: "M856,-32C1164,-32 1371,135 1441,328l-169,55C1213,245 1074,131 856,131C542,131 343,360 335,715l1144,0l0,88C1479,1316 1162,1557 829,1557C431,1557 156,1224 156,759C156,293 426,-32 856,-32M336,872C355,1158 548,1395 829,1395C1104,1395 1297,1168 1297,872z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1643,
    d: "M413,960C413,1228 593,1393 839,1393C1077,1393 1229,1237 1229,984l0,-984l179,0l0,995C1408,1361 1196,1556 884,1556C652,1556 501,1454 429,1295l-16,0l0,753l-178,0l0,-2048l178,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 653,
    d: "M237,0l179,0l0,1536l-179,0M328,1800C401,1800 462,1858 462,1928C462,1998 401,2056 328,2056C255,2056 195,1998 195,1928C195,1858 255,1800 328,1800z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 648,
    d: "M413,2048l-178,0l0,-2048l178,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 2416,
    d: "M235,0l178,0l0,984C413,1223 572,1393 785,1393C995,1393 1117,1253 1117,1045l0,-1045l182,0l0,1011C1299,1232 1431,1393 1665,1393C1868,1393 2003,1271 2003,1029l0,-1029l178,0l0,1029C2181,1373 2004,1556 1719,1556C1495,1556 1333,1447 1264,1277l-13,0C1183,1451 1048,1556 836,1556C635,1556 485,1459 424,1300l-16,0l0,236l-173,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1632,
    d: "M413,960C413,1228 589,1393 831,1393C1067,1393 1219,1235 1219,984l0,-984l178,0l0,995C1397,1359 1186,1556 876,1556C651,1556 496,1452 424,1295l-16,0l0,241l-173,0l0,-1536l178,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1664,
    d: "M832,-32C1230,-32 1508,293 1508,761C1508,1232 1230,1557 832,1557C434,1557 156,1232 156,761C156,293 434,-32 832,-32M832,131C513,131 335,417 335,761C335,1105 513,1395 832,1395C1151,1395 1329,1105 1329,761C1329,417 1151,131 832,131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1689,
    d: "M235,-576l178,0l0,861l16,0C491,144 623,-32 901,-32C1277,-32 1533,288 1533,764C1533,1238 1278,1557 899,1557C616,1557 492,1381 429,1243l-21,0l0,293l-173,0M411,767C411,1135 579,1395 880,1395C1189,1395 1355,1121 1355,767C1355,409 1185,131 880,131C583,131 411,396 411,767z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 1004,
    d: "M235,0l178,0l0,992C413,1220 588,1385 828,1385C875,1385 919,1377 935,1375l0,181C911,1557 870,1559 841,1559C648,1559 483,1455 421,1300l-13,0l0,236l-173,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 1009,
    d: "M840,1536l-325,0l0,368l-179,0l0,-368l-229,0l0,-155l229,0l0,-1022C336,108 534,-23 731,-23C805,-23 855,-9 889,4l-38,161C826,158 794,151 747,151C626,151 515,208 515,401l0,980l325,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1624,
    d: "M1211,587C1211,305 999,153 791,153C569,153 413,312 413,552l0,984l-178,0l0,-995C235,177 445,-20 740,-20C965,-20 1125,97 1197,255l14,0l0,-255l178,0l0,1536l-178,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1536,
    d: "M1424,1536l-193,0l-456,-1301l-14,0l-456,1301l-193,0l561,-1536l190,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1536,
    d: "M359,-576C551,-576 692,-466 774,-243l650,1779l-193,0l-456,-1301l-14,0l-456,1301l-193,0l565,-1551l-56,-156C536,-403 416,-444 235,-387l-48,-157C223,-561 289,-576 359,-576z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 15.5,
    className: "st0",
    width: 116.2,
    height: 26.8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 18.2106 22.7671)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st1 st2 st3"
  }, "Complete the GLEAM "), /*#__PURE__*/React.createElement("tspan", {
    x: 22.5,
    y: 14,
    className: "st1 st2 st3"
  }, "competition"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85,75.5l-9.7,9.7H61.6l-9.7-9.7V61.7l9.7-9.7h13.7l-6.9,16.6l0.1,0L85,61.8L85,75.5L85,75.5L85,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.6,52l-9.7,9.7l16.6,6.9L61.6,52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M75.3,52H61.6l6.9,16.6L75.3,52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.3,85.1l9.7-9.7l-16.6-6.9L75.3,85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M61.6,85.1h13.7l-6.9-16.6L61.6,85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M51.8,75.4l9.7,9.7l6.9-16.6L51.8,75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M51.8,61.7v13.7l16.6-6.9L51.8,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M85,75.5V61.8l-16.6,6.9L85,75.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M137.6,100.2H5.9c-3.1,0-5.7-2.5-5.7-5.7V5.9c0-3.1,2.5-5.7,5.7-5.7h131.6c3.1,0,5.7,2.5,5.7,5.7v88.6 C143.2,97.7,140.7,100.2,137.6,100.2z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 182.5,
    y: 15.5,
    className: "st0",
    width: 81.2,
    height: 26.8
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 193.3017 22.7671)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st1 st2 st3"
  }, "Approve and "), /*#__PURE__*/React.createElement("tspan", {
    x: -2.8,
    y: 14,
    className: "st1 st2 st3"
  }, "Mint your XFT"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M288.9,100.2H157.3c-3.1,0-5.7-2.5-5.7-5.7V5.9c0-3.1,2.5-5.7,5.7-5.7h131.6c3.1,0,5.7,2.5,5.7,5.7v88.6 C294.6,97.7,292.1,100.2,288.9,100.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M216.7,113.9v11.6c0,3.1-2.5,5.7-5.7,5.7H79.4c-3.1,0-5.7-2.5-5.7-5.7v-11.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.1,114.8c-0.1-0.3-0.3-0.5-0.6-0.4c0,0-0.1,0-0.1,0c-0.2,0.1-0.3,0.3-0.3,0.6c0.5,2.7-0.5,5.4-2.7,7 c-1.5,1.1-3.3,1.5-5.2,1.3c-1.9-0.3-3.5-1.3-4.6-2.8c-2.3-3.1-1.6-7.5,1.5-9.8c1.5-1.1,3.3-1.5,5.2-1.3c1.8,0.3,3.4,1.2,4.5,2.6 l-0.5-0.1c-0.3,0-0.5,0.2-0.6,0.4c0,0.3,0.2,0.5,0.4,0.6l1.7,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0.3,0,0.5-0.2,0.5-0.4l0.2-1.7 c0-0.3-0.2-0.5-0.4-0.6c-0.3,0-0.5,0.2-0.6,0.4l-0.1,0.5c-1.3-1.6-3.1-2.7-5.1-3c-2.1-0.3-4.2,0.2-6,1.4c-1.7,1.3-2.8,3.1-3.2,5.2 c-0.3,2.1,0.2,4.2,1.4,6c1.3,1.7,3.1,2.8,5.2,3.2c0.4,0.1,0.8,0.1,1.3,0.1c1.7,0,3.3-0.5,4.7-1.5 C153.5,121,154.7,117.8,154.1,114.8L154.1,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149,116.5h-1.7c-0.1-0.3-0.4-0.5-0.7-0.7V112c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5v3.9 c-0.4,0.2-0.8,0.6-0.8,1.2c0,0.7,0.6,1.3,1.3,1.3c0.5,0,1-0.3,1.2-0.8h1.7c0.3,0,0.5-0.2,0.5-0.5S149.3,116.5,149,116.5z  M145.9,117.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.2,0.2C146,117.3,145.9,117.2,145.9,117.1z"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 144.5,
    className: "st0",
    width: 109.6,
    height: 14.8
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 132.3257 151.7671)",
    className: "st1 st13 st3"
  }, "1 hour")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M249.9,79.4h-53.6c-5.4,0-9.7-4.3-9.7-9.7v-2.3c0-5.4,4.3-9.7,9.7-9.7h53.6c5.4,0,9.7,4.3,9.7,9.7v2.3 C259.6,75.1,255.3,79.4,249.9,79.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,65.1l1.9,4.6h0.1l1.9-4.6h2.2v7.4h-1.7v-4.5h-0.1l-1.8,4.5h-1.1l-1.8-4.5h-0.1v4.5H201v-7.4H203.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.3,65.4c0-0.5,0.4-0.8,0.9-0.8c0.5,0,0.9,0.4,0.9,0.8c0,0.5-0.4,0.8-0.9,0.8 C210.7,66.3,210.3,65.9,210.3,65.4z M210.3,66.9h1.8v5.5h-1.8V66.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215,72.4h-1.8v-5.5h1.7v1h0.1c0.2-0.7,0.9-1.1,1.7-1.1c1.2,0,1.9,0.8,1.9,2.1v3.5h-1.8v-3.2 c0-0.6-0.3-1-0.9-1c-0.6,0-0.9,0.4-0.9,1V72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.8,68.2h-1v2.5c0,0.3,0.2,0.4,0.4,0.4c0.1,0,0.3,0,0.4-0.1l0.3,1.3c-0.2,0.1-0.5,0.1-0.9,0.2 c-1.2,0.1-2-0.5-2-1.6v-2.7h-0.7v-1.3h0.7v-1.3h1.8v1.3h1V68.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229,67.4L229,67.4l1.4-2.3h2l-2.2,3.7l2.3,3.7h-2l-1.4-2.4H229l-1.4,2.4h-2l2.3-3.7l-2.2-3.7h2L229,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.3,65.1h5v1.4h-3.2V68h2.9v1.4h-2.9v3h-1.8V65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239,65.1h6.2v1.4H243v5.9h-1.8v-5.9H239V65.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectGalaxyStepsV2);
export default __webpack_public_path__ + "static/media/project_galaxy_steps_v2.3fb6e178cf1ba7964ec2a68605f8b298.svg";
export { ForwardRef as ReactComponent };